import type { FaireProductEntity } from "../../entity_types/product";

export const p_up9397d8tp: FaireProductEntity = {
  token: "p_up9397d8tp",
  type: "product",
  name: "Golden Coast - 12.5 oz Large Concentrated Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/c725834c11ad2e97bffbee568b343bff12c2692403d69be71d3d41aa27dcddeb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b649f96fad71d1608b708e9493a280ff7742d7d71c611472f7caddc6120f8820.jpeg",
    "https://cdn.faire.com/fastly/18480acd82545860c9e1cf128309f063d1c58722eeedfe51f460618b439a4288.jpeg",
    "https://cdn.faire.com/fastly/6129e5dcd93dd7ca399f380c0fdf10b9f7bf7c0dd273ead7c409f0d22b8ed7cc.jpeg",
    "https://cdn.faire.com/fastly/491f3a8ad9bcb1cea44f68bfc1119c2bc6992c1901bce3368718a37322f9ff73.jpeg",
    "https://cdn.faire.com/fastly/afbe679981c3d3e032816803c911acc1445fb493b8af6041a885784071de9717.jpeg",
    "https://cdn.faire.com/fastly/2c0513b366ce92444a1ba54c40ea2665868f10ed7e7aa4b35faecbd9760f7e3f.jpeg",
  ],
  priceDollars: 18,
  description:
    "Big Sur magic, wild sage baking in the sun, the rumble of waves and rocks. Notes of eucalyptus, sea salt, redwood, and palo santo.\n\nOur 12.5 oz Large Candles are hand-poured into apothecary-inspired amber jars with our signature kraft label and a brass lid. \n\nOur candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 60-70 hours.",
  tags: [],
  msrpDollars: 37.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:50.211Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
